/**
 * @flow
 * @relayHash 5ddc535a159c9de4e6d2b78b847fd5b6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type cityListPage_query$ref = any;
export type srcCityListQueryVariables = {||};
export type srcCityListQueryResponse = {|
  +$fragmentRefs: cityListPage_query$ref
|};
export type srcCityListQuery = {|
  variables: srcCityListQueryVariables,
  response: srcCityListQueryResponse,
|};
*/


/*
query srcCityListQuery {
  ...cityListPage_query
}

fragment cityListPage_query on Query {
  citiesOverview {
    cover
    seo {
      title
      description
    }
    social {
      twitter {
        type
        title
        image
        handle
        description
      }
      generic {
        title
        image
        description
      }
    }
  }
  cities {
    slug
    name
    caption
    picture
    color
    featured
    availability
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "srcCityListQuery",
  "id": null,
  "text": "query srcCityListQuery {\n  ...cityListPage_query\n}\n\nfragment cityListPage_query on Query {\n  citiesOverview {\n    cover\n    seo {\n      title\n      description\n    }\n    social {\n      twitter {\n        type\n        title\n        image\n        handle\n        description\n      }\n      generic {\n        title\n        image\n        description\n      }\n    }\n  }\n  cities {\n    slug\n    name\n    caption\n    picture\n    color\n    featured\n    availability\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "srcCityListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "cityListPage_query",
        "args": null
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "srcCityListQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "citiesOverview",
        "storageKey": null,
        "args": null,
        "concreteType": "CitiesListPage",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cover",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "seo",
            "storageKey": null,
            "args": null,
            "concreteType": "SEO",
            "plural": false,
            "selections": [
              v0,
              v1
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "social",
            "storageKey": null,
            "args": null,
            "concreteType": "SocialMedia",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "twitter",
                "storageKey": null,
                "args": null,
                "concreteType": "TwtrSlices",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "type",
                    "args": null,
                    "storageKey": null
                  },
                  v0,
                  v2,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "handle",
                    "args": null,
                    "storageKey": null
                  },
                  v1
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "generic",
                "storageKey": null,
                "args": null,
                "concreteType": "GenSocialSlices",
                "plural": true,
                "selections": [
                  v0,
                  v2,
                  v1
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "cities",
        "storageKey": null,
        "args": null,
        "concreteType": "City",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "slug",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "caption",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "picture",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "color",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "featured",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "availability",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '81ef57c96c38c0d482544ec1022c9044';
module.exports = node;
